<template>
  <the-header @toggle-sidebar="sidebarOpen = !sidebarOpen" />
  <main>
    <side-bar v-if="showSidebar" :open="sidebarOpen" @navigate="sidebarOpen = false" />
    <div
      v-if="showSidebar && sidebarOpen"
      class="sidebar-backdrop md:hidden"
      @click="sidebarOpen = false"
    ></div>
    <router-view :class="showSidebar ? 'ml-0 md:ml-[93px] w-full' : 'ml-0 w-full'" />
  </main>
  <MarvinButton v-if="!hideMarvin" @open-chat="isMarvinOpen = true" />
  <MarvinChat v-if="!hideMarvin" v-model="isMarvinOpen" />
</template>

<script>
import SideBar from "@/components/SideBar.vue";
import TheHeader from "@/components/TheHeader.vue";
import MarvinButton from "@/features/Marvin/MarvinButton.vue";
import MarvinChat from "@/features/Marvin/MarvinChat.vue";
import { decryptText } from "@/utils/cryptFunc";

export default {
  components: { SideBar, TheHeader, MarvinButton, MarvinChat },
  data() {
    return {
      isMarvinOpen: false,
      sidebarOpen: false,
      showSidebar: true,
      isManager: localStorage.getItem("isManager"),
      role: decryptText(localStorage.getItem("role")),
      sideBarRoles: [
        "audit",
        "admin",
        "finance",
        "examiner",
        "instructor",
        "kurator",
        "marketing",
        "axo",
        "hunter",
        "tutor",
        "moderator",
        "academy",
        "branchacademy",
        "hr",
        "metodist",
      ],
    };
  },
  computed: {
    // Marvin (плавающая иконка-марсианин) перекрывает таблицы на дашборде
    // статистики — прячем её там. (Max 2026-06-28.)
    hideMarvin() {
      return this.$route.name === "statistics-dashboard";
    },
  },
  beforeMount() {
    this.routeNameCheck();
  },
  watch: {
    $route() {
      this.routeNameCheck();
    },
  },
  methods: {
    routeNameCheck() {
      if (this.sideBarRoles.includes(this.role)) {
        this.showSidebar = true;
        if (this.role === "axo" && window.innerWidth < 576) {
          this.showSidebar = false;
        }
      } else {
        this.showSidebar = false;
      }
    },
  },
};
</script>
